import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=197aa05e&scoped=true"
import script from "./PersonDetail.vue?vue&type=script&lang=js"
export * from "./PersonDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&id=197aa05e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aa05e",
  null
  
)

export default component.exports